import moment from 'moment'
import { isEmpty } from 'lodash'

import { SelectDropdown as SelectDropdownType } from 'types/SelectDropdown'
import { CustomDateRange } from 'types/ReportingDashboardFilter'

const checkWithinRange = (dateRange: CustomDateRange) => {
  const startDate = moment(dateRange.startDate)
  const endDate = moment(dateRange.endDate)
  const isDateWithinRange = Math.abs(startDate.diff(endDate, 'days')) + 1 <= 180

  return isDateWithinRange
}

interface setFilterDropDownProps {
  option?: string
  dateRange: CustomDateRange
  activityFilterOptions: SelectDropdownType
}
export const setFilterDropdown = ({
  option,
  dateRange,
  activityFilterOptions,
}: setFilterDropDownProps) => {
  const getActivityFilterType = checkWithinRange(dateRange)
  const interval = getActivityFilterType ? 'daily' : option

  if (!isEmpty(activityFilterOptions)) {
    for (const option of activityFilterOptions) {
      if (getActivityFilterType && option.value === 'monthly')
        option.disabled = true
      else option.disabled = false
    }
  }
  return interval
}
